<h1 mat-dialog-title>{{ data }}.</h1>

<div mat-dialog-content>Continue?</div>

<div mat-dialog-actions>
  <button class="btn-product margin-right-6" [mat-dialog-close]="true">Confirm</button>
  <button class="btn-product" [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
</div>
